
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/keycodes",
      function () {
        return require("private-next-pages/keycodes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/keycodes"])
      });
    }
  